<template lang="pug">
.confirm-card
  .card
    ticket-card
  .info
    .title
      .fs-m {{ticket.ticketName}}
    .ticket-detail
      member-icon-text(:grade="grade")
      .price-info
        .price.cl-orange.fs-s ￥{{ticket.ticketMoney}}/人
        .price-desc.fs-s.cl-gray *儿童半价
    .detail
      .row
        .key 参观人员
        .value {{users}}
      .row
        .key 金额支付
        .value {{moneyDetail}}
    //.point
      point-deduct
    .total
      .row
        .key 合计
        .value ￥{{money}}
    

  
</template>
<script>
import TicketCard from '@/components/wedgits/TicketCard'
import TimeRange from '@/components/wedgits/TimeRange'
import FamStack from '@/components/wedgits/FamStack'
import PointDeduct from '@/components/res/PointDeduct'
import { mapState, mapGetters } from 'vuex'
import AvatarStack from '@/components/wedgits/AvatarStack'
import Member from '@/components/wedgits/Member'
import MemberIcon from '@/components/wedgits/MemberIcon'
import MemberIconText from '@/components/wedgits/MemberIconText'
export default {
  name: 'TicketConfirmCard',
  components: {
    MemberIconText,
    MemberIcon,
    Member,
    AvatarStack,
    PointDeduct,
    FamStack,
    TimeRange,
    TicketCard,
  },
  props: {
    ticketId: {},
  },
  data() {
    return {
      adultCnt: 0,
      childCnt: 0,
      money: 0,
      point: 0,
    }
  },
  watch: {
    ticketId(val) {
      this.genOrderInfo()
    },
  },
  computed: {
    ...mapState('app', ['schedulePicked', 'user', 'ticketPicked']),
    ...mapGetters('app', ['fams']),
    ticket() {
      return this.user.tickets.filter((t) => {
        return t.ticketId === parseInt(this.ticketId)
      })[0]
    },
    grade() {
      return this.user.grade
    },
    year() {
      return this.schedulePicked.from.getFullYear()
    },
    month() {
      return this.schedulePicked.from.getMonth() + 1
    },
    date() {
      return this.schedulePicked.from.getDate()
    },
    avatars() {
      // return this.fams.map((u) => {
      //   return u.avatar
      // })
      return this.user.famUsers.map((u) => {
        return u.avatar
      })
    },
    ticketType() {
      return this.ticketPicked.title
    },
    users() {
      return this.childCnt > 0
        ? `${this.adultCnt}成人, ${this.childCnt}儿童`
        : `${this.adultCnt}成人`
    },
    moneyDetail() {
      return this.childCnt > 0
        ? `￥${this.ticket.ticketMoney}X${this.adultCnt}+￥${this.ticket
            .ticketMoney / 2}X${this.childCnt}`
        : `￥${this.ticket.ticketMoney}X${this.adultCnt}`
    },
    total() {
      return `￥${this.money}`
    },
  },
  created() {
    //this.genInfo()
    this.genOrderInfo()
  },
  methods: {
    genInfo() {
      this.user.famUsers.map((u) => {
        if (u.userType === 0) {
          this.adultCnt++
        } else {
          this.childCnt++
        }
      })
      console.log(this.childCnt)
      this.money =
        this.ticketPicked.money * this.adultCnt +
        (this.ticketPicked.money * this.childCnt) / 2
    },
    genOrderInfo() {
      this.user.famUsers.map((u) => {
        if (u.userType === 0) {
          this.adultCnt++
        } else {
          this.childCnt++
        }
      })
      this.money =
        this.ticket.ticketMoney * this.adultCnt +
        (this.ticket.ticketMoney * this.childCnt) / 2
    },
    calcTicketOrder(id) {
      this.ticket = this.user.tickets.filter((t) => {
        return t.ticketId === parseInt(id)
      })[0]
      console.log('ticket on sale', this.ticket)
    },
  },
  mounted() {
    //this.calcTicketOrder()
    //this.genInfo()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.confirm-card
  position: relative
  width: 100%
  height: 100%
  .card
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
  .info
    position: relative
    z-index: 10
    width: 100%
    height: 100%
    padding: pxToRem(38) pxToRem(80)
    .ticket-detail
      width: 100%
      display: flex
      flex-direction: row
      align-items: flex-start
      justify-content: space-between
      .price-info
        display: flex
        flex-direction: column
        align-items: flex-end
    .detail
      margin-top: pxToRem(50)
      width: 100%
      .row
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        font-size: pxToRem(26)
        margin-bottom: pxToRem(15)
        .value
    .total
      animation: fadeIn 0.7s $easeOutCubic both 0.6s
      margin-top: pxToRem(60)
      .row
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        font-size: pxToRem(32)
        .value
          color: $cl-orange
@keyframes fadeIn
  0%
    opacity: 0
    transform: translateY(20%)
  100%
    opacity: 1
    transform: translateY(0)
</style>
